<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" temporary app>
      <v-list nav>
        <v-list-item-group>
          <v-list-item to="/">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="$t('label.search')"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-subheader class="mt-3 grey--text text--darken-1">CASE MANAGEMENT</v-subheader>

          <v-list-item to="/casemanager">
            <v-list-item-icon>
              <v-icon>mdi-database-search</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="$t('label.caseManager')"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/casegroups">
            <v-list-item-icon>
              <v-icon>mdi-account-multiple-check</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="$t('label.caseGroups')"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-subheader class="mt-3 grey--text text--darken-1">COMPLIANCE</v-subheader>

          <v-list-item to="/resolution" :disabled="!hasPermission('CAN_VIEW_RESOLUTION')">
            <v-list-item-icon>
              <v-icon>mdi-clipboard-check</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Case Reports</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-subheader class="mt-3 grey--text text--darken-1">SYSTEM</v-subheader>

          <v-list-item to="/settings">
            <v-list-item-icon>
              <v-icon>mdi-settings</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="$t('label.settings')"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-subheader class="mt-3 grey--text text--darken-1">Help</v-subheader>

          <v-list-item href="https://docs.verizent.com" target="_blank">
            <v-list-item-icon>
              <v-icon>mdi-help</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Guide
                <v-icon small>mdi-open-in-new</v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item href="/swagger-ui/index.html" target="_blank">
            <v-list-item-icon>
              <v-icon>mdi-book</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                API Docs
                <v-icon small>mdi-open-in-new</v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app elevation="0">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <router-link to="/">
        <v-img
          class="shrink mr-2"
          contain
          src="../assets/logo.png"
          transition="scale-transition"
          width="40" />
      </router-link>

      <span class="mt-1">
        {{ $t("label.veriscan") }}
      </span>

      <v-spacer />

      <v-menu offset-y transition="slide-x-reverse-transition">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" dark color="primary" fab small>
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list width="150">
          <v-list-item-group color="primary">
            <v-list-item to="settings">
              <v-list-item-icon>
                <v-icon>mdi-settings</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="$t('label.settings')"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item href="https://docs.verizent.com" target="_blank">
              <v-list-item-icon>
                <v-icon>mdi-help</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="$t('label.help')"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item @click="logout()">
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="$t('label.logout')"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <GlobalAlert :globalAlert="globalAlert"> </GlobalAlert>
      <v-container fluid>
        <keep-alive include="Search">
          <router-view />
        </keep-alive>
      </v-container>
    </v-main>
    <v-footer app>
      <!-- -->
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import GlobalAlert from "../components/GlobalAlert";
import { hasPermission } from "../utils/permission";
export default {
  name: "Home",
  components: { GlobalAlert },
  data() {
    return {
      drawer: false,
    };
  },
  methods: {
    hasPermission,
    ...mapActions([
      "logoutRequest",
      "loadAppConfig",
      "fetchCaseGroups",
      "getUsers",
      "setGlobalAlert",
    ]),
    logout: function () {
      this.logoutRequest().then(() => {
        this.$router.push("/user-login");
      });
    },
    menu: function () {
      return [
        { id: 0, text: this.$t("label.settings"), icon: "mdi-settings" },
        { id: 1, text: this.$t("label.help"), icon: "mdi-help" },
        {
          id: 2,
          text: this.$t("label.logout"),
          icon: "mdi-logout",
          action: "logout",
        },
      ];
    },
  },
  computed: {
    ...mapGetters(["userDetails", "getGlobalAlert"]),
    globalAlert() {
      return this.$store.state.globalAlert.alert;
    },
  },
  props: {},
  created() {
    this.loadAppConfig().catch(() => {
      // TODO add global alert or is it already hanled globally by interceptor?
      console.error("Error loading app config");
    });

    // Fetch case groups, they are needed on most pages (case manager, resolution)
    this.fetchCaseGroups().catch((e) => {
      console.error("Error getting groups: " + e);
      this.setGlobalAlert({
        alert: true,
        color: "red",
        alertTitle: "There's been a problem.",
        alertMessage:
          "Unable to retreive case group settings. Some pages may not work properly. Please log out and log back in.",
      });
    });

    this.getUsers().catch((error) => {
      console.log("Error getting users for assigned users.", error);
      this.setGlobalAlert({
        alert: true,
        color: "red",
        alertTitle: "There's been a problem.",
        alertMessage:
          "Unable to retreive user settings. Some pages may not work properly. Please log out and log back in.",
      });
    });
  },
};
</script>

<style>
/* Fixes unaligned headers */
.v-data-table-header th {
  white-space: nowrap;
}
#keep .v-navigation-drawer__border {
  display: none;
}
.no-uppercase {
  text-transform: none;
}
</style>
